import { BTN_TXT } from '../../../../constants'

export const DISPUTE_PROCESS_CANT_BE_DONE_TYPES = {
  CENTRAL_DISPUTE_LOCATION: 'central_dispute_location',
  SOME_DISPUTES_UNAVAILABLE: 'some_disputes_unavailable',
  DISPUTE_UNAVAILABLE: 'dispute_unavailable'
} as const

export type DisputeProcessCantBeDoneType =
  typeof DISPUTE_PROCESS_CANT_BE_DONE_TYPES[keyof typeof DISPUTE_PROCESS_CANT_BE_DONE_TYPES]

export const DISPUTE_PROCESS_CANT_BE_DONE_CONFIG = {
  [DISPUTE_PROCESS_CANT_BE_DONE_TYPES.CENTRAL_DISPUTE_LOCATION]: {
    title: 'Contest needs to occur from central dispute location',
    paragraphs: ['Start the dispute from the related calculation:'],
    footer: {
      cancel: BTN_TXT.CANCEL,
      primary: BTN_TXT.GO_TO_REBATES,
      goToRebates: true
    }
  },
  [DISPUTE_PROCESS_CANT_BE_DONE_TYPES.SOME_DISPUTES_UNAVAILABLE]: {
    title: 'Some disputes are no longer available',
    paragraphs: [
      'Invoices included in paid rebate calculations can no longer be disputed.',
      'The remaining invoices can only be disputed from the Rebates tab. Start the dispute from the related calculation:'
    ],
    footer: {
      cancel: BTN_TXT.CANCEL,
      primary: BTN_TXT.GO_TO_REBATES,
      goToRebates: true
    }
  },
  [DISPUTE_PROCESS_CANT_BE_DONE_TYPES.DISPUTE_UNAVAILABLE]: {
    title: 'Dispute is no longer available',
    paragraphs: [
      'Invoices included in paid rebate calculations can no longer be disputed.'
    ],
    footer: {
      cancel: null,
      primary: BTN_TXT.GOT_IT,
      goToRebates: false
    }
  }
} as const
